module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold.858c037d.ttf";